/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect, useState } from 'react';
import { usePaymentsStatusBinding } from '../../eligibility/eligibilityBinding';
import { hasCompletedUnderwritingReview, useKYCStatus } from '../../eligibility/utils';
var GoToPaymentsButtonType;
(function (GoToPaymentsButtonType) {
  GoToPaymentsButtonType["applicationPending"] = "applicationPending";
  GoToPaymentsButtonType["applicationReviewed"] = "applicationReviewed";
  GoToPaymentsButtonType["paymentsActivated"] = "paymentsActivated";
})(GoToPaymentsButtonType || (GoToPaymentsButtonType = {}));
export const useGoToPaymentsButtonType = () => {
  const kycStatus = useKYCStatus();
  const [paymentsStatus, fetchPaymentsStatus] = usePaymentsStatusBinding();
  const [type, setType] = useState(null);
  useEffect(() => {
    if (!paymentsStatus) {
      fetchPaymentsStatus();
    }
  }, [paymentsStatus, fetchPaymentsStatus]);
  useEffect(() => {
    if (kycStatus !== undefined && paymentsStatus) {
      const {
        isActivated
      } = paymentsStatus;
      if (isActivated) {
        setType(GoToPaymentsButtonType.paymentsActivated);
      } else if (hasCompletedUnderwritingReview(kycStatus)) {
        setType(GoToPaymentsButtonType.applicationReviewed);
      } else {
        setType(GoToPaymentsButtonType.applicationPending);
      }
    }
  }, [kycStatus, paymentsStatus]);
  return type;
};